import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import AiccBreadCrumb from "components/common/AiccBreadCrumb";
import { ContentCard } from "components/ContentCard";
import { UserListGrid } from "../components/UserListGrid";
import routeUserApi from "services/apis/routeUserApi";
import { getPathPrefix } from "utils/coreUtils";
import { UserFormTypes } from "constants/index";

export default function RoutingUserList() {
  const [search, setSearch] = useState("");
  const [companyUserListData, setCompanyUserListData] = useState([]);
  const [isLoading] = useState(false);
  const datastreamList = useSelector((state) => state?.datastream?.list);

  const [t] = useTranslation();

  const companyUserId = useMemo(
    () => localStorage.getItem("companyUserId"),
    []
  );

  const getRoutingUserList = async (showToast) => {
    try {
      const response = await routeUserApi.getRoutingUser({
        companyId: localStorage.getItem("companyId"),
        namesearch: search,
      });
      setCompanyUserListData(response.data.response);

      if (showToast) {
        toast.success(t("userList.refreshSuccess"));
      }
    } catch (error) {
      /* empty */
    }
  };

  const checkHandler = async (companyUserId) => {
    try {
      await routeUserApi.updateStatusOrDelete("s", companyUserId);
      toast.success("Status updated");

      getRoutingUserList();
    } catch (error) {
      /* empty */
    }
  };

  const handleDeleteUser = async (companyUserId) => {
    try {
      await routeUserApi.updateStatusOrDelete("d", companyUserId);
      toast.success("User deleted");

      getRoutingUserList();
    } catch (error) {
      /* empty */
    }
  };

  const getConfigNames = (configIds) => {
    return datastreamList
      ?.filter((e) => configIds.includes(e.dataStreamConfigId))
      .map((e) => e.customDataStreamName)
      .join(", ");
  };

  useEffect(() => {
    let timeout = undefined;

    if (search.trim() === "") {
      getRoutingUserList();
    } else {
      timeout = setTimeout(() => {
        getRoutingUserList();
      }, 800);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [search]);

  return (
    <>
      <AiccBreadCrumb
        title={t("userList.mainBreadcrumbTitle")}
        items={[
          {
            name: t("userList.routingBreadcrumbName"),
          },
        ]}
      />
      <div className="col-12">
        <ContentCard
          headerImgSrc="/assets/images/user.svg"
          title={t("userList.routingTitle")}
          headerContent={
            <div className="d-block d-md-flex justify-content-end">
              <NavLink
                to={getPathPrefix(
                  `company-user/create-user?t=${UserFormTypes.CREATE_USER}&r=ru`
                )}
                type="button"
                className="btn btn-main-primary"
              >
                <i className="fa-solid fa-plus me-2"></i>
                {t("userList.addUserButtonTitle")}
              </NavLink>
              <a
                type="button"
                className="btn ms-md-3 btn-main-primary"
                onClick={async () => {
                  await getRoutingUserList(true);
                }}
              >
                <i className="fa-sharp fa-solid fa-rotate me-2"></i>
                {t("userList.refreshUserButtonTitle")}
              </a>
            </div>
          }
          bodyContent={
            <>
              <div className="form">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("userList.searchHint")}
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <UserListGrid
                  userListKey="routing-user"
                  list={companyUserListData}
                  toggleActiveStatusHandler={checkHandler}
                  handleDeleteUser={handleDeleteUser}
                  userRole={UserFormTypes.ROUTING_USER}
                  loggedInUserId={companyUserId}
                  getConfigNames={getConfigNames}
                  noUserMessage={t("errorKeys.noRoutingUserFound")}
                />
              </div>
            </>
          }
        />
      </div>

      <div className="d-sm-flex justify-content-center">
        {isLoading && (
          <img
            src={"/assets/images/loader_gif.gif"}
            height={"50"}
            width={"50"}
            align={"center"}
          />
        )}
      </div>
    </>
  );
}
